import { Spinner } from '@chakra-ui/react';

export const Loading = () => {
  return (
    <Spinner mx="2"/>
  );
}

